import { z } from "zod";

export const fullAddressSchema = z.object({
  manualMsa: z.boolean().nullish(),
  city: z.string(),
  region: z.string().optional(),
  state: z.string(),
  stateCode: z.string(),
  country: z.string(),
  countryCode: z.string(),
  formatted: z.string(),
  metropolitanStatisticalArea: z.string(),
  combinedStatisticalArea: z.string().nullish(),
  streetNumber: z.string().optional(),
  streetName: z.string().optional(),
  postalCode: z.string().optional(),
  line1: z.string().optional(),
  subpremise: z.string().optional(),
});

export type FullAddress = z.infer<typeof fullAddressSchema>;

export const locationSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});

export type Location = z.infer<typeof locationSchema>;

export const geoLocationSchema = z.object({
  coordinates: z.tuple([z.number(), z.number()]),
  type: z.string(),
});

export type GeoLocation = z.infer<typeof geoLocationSchema>;
